/** OpenLayers grid-system factory for IberianPeninsula; the theatre data itself is ol-free in `IberianPeninsula.ts`. */
import { IBERIAN_PENINSULA_SCHEME } from '../formatters/schemes.js';
import { createMBSGridSystem } from './shared.js';
import { IBERIAN_PENINSULA_CLIP_POLYGON, IBERIAN_PENINSULA_CRS, IBERIAN_PENINSULA_PROJ4, } from './IberianPeninsula.js';
export function createIberianPeninsulaGridSystem(options) {
    return createMBSGridSystem(IBERIAN_PENINSULA_CRS, IBERIAN_PENINSULA_PROJ4, IBERIAN_PENINSULA_SCHEME, IBERIAN_PENINSULA_CLIP_POLYGON, options);
}
//# sourceMappingURL=IberianPeninsula.grid.js.map